import React, { ReactNode } from "react";
import {
  Box,
  CustomMultiSelect,
  MultiSelectCustomTarget,
  ItemType,
  TitleComponent,
  CustomButton
} from "ui-components";
import {
  Intent,
  FileInput,
} from "@blueprintjs/core";

type Props = {
  selectedFile: File | undefined;
  handleFileChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  setCountryCode: (e: string) => void;
  currentCountryCode: string;
  setCurrentStatusCode: (data: string[]) => void;
  currentStatusCode: string[];
  handleRemove: () => void;
  handleUpdate: (data: any) => void;
  handleOnResetClick: () => void;
  selectedTableData: Record<string, string>[];
};
let statusOptions = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
  {
    label: "Closed",
    value: "closed",
  },
  {
    label: "Dissolved",
    value: "dissolved",
  },
];
const FiltersContainer = (props: Props) => {
  const {
    selectedFile,
    handleFileChange,
    setCurrentStatusCode,
    currentStatusCode,
    handleRemove,
    handleUpdate,
    handleOnResetClick,
    selectedTableData,
  } = props;

  
  const renderCustomTarget = (selectedItems: ItemType[]) => (
    <MultiSelectCustomTarget
      count={selectedItems.length}
      text={`Status selected`}
    />
  );
	const handleStatusRemove = (val:ReactNode) =>{
		const valueStr = String(val).toLowerCase();
		let statusArray = [...currentStatusCode];
		if (currentStatusCode.includes(valueStr)) {
			statusArray = statusArray.filter((v) => v !== valueStr);
			setCurrentStatusCode([...statusArray]);
		}
	}

  return (
    <Box p="medium">
      <Box flexDir="row" justify="between" items="baseline" mb="medium">
        <TitleComponent fontSize="14px" marginTop="5px">
          Filters
        </TitleComponent>
        <CustomButton
          text="Reset"
          small
          minimal
          intent={Intent.PRIMARY}
          onClick={handleOnResetClick}
        />
      </Box>
      <FileInput
        text={selectedFile?.name ?? "Select a file to upload"}
        fill
        onInputChange={handleFileChange}
      />
      <Box mt={"medium"}>
        <Box mt={"xsmall"}>
          <TitleComponent fontSize="14px" marginTop="5px">
            Status
          </TitleComponent>
        </Box>

        <CustomMultiSelect
          items={statusOptions ?? []}
          values={currentStatusCode ?? []}
          onSelect={(item: ItemType) => {
            let newValues;
						if(currentStatusCode.includes(item.value)){
							newValues = currentStatusCode.filter((ele:string) => ele!==item.value)
						}
						else newValues = [...currentStatusCode,item.value];
            setCurrentStatusCode(newValues);
          }}
          onRemove={(_value) => {
            handleStatusRemove(_value)
          }}
          customTarget={
            currentStatusCode.length > 2 ? renderCustomTarget : undefined
          }
        />
      </Box>
  
      <Box flexDir="col">
        {selectedTableData.length > 0 && (
          <Box flexDir="row" justify="between">
            <Box flexDir="col"></Box>
            <Box flexDir="row" items="center" gap={"xsmall"}>
              <TitleComponent fontSize="14px">Rows Selected :</TitleComponent>
              <TitleComponent fontSize="15px">
                {selectedTableData?.length}{" "}
              </TitleComponent>
            </Box>
          </Box>
        )}
        <Box
          flexDir="row"
          mt={selectedTableData?.length > 0 ? "0" : "large"}
          justify="between"
        >
          <CustomButton
		  	intent={Intent.DANGER}
            bradius="5px"
            onClick={handleRemove}
          >
            Remove
          </CustomButton>
          <CustomButton
		  	intent={Intent.SUCCESS}
            bradius="5px"
            onClick={() => handleUpdate(selectedTableData)}
          >
            Update
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
};
export default FiltersContainer;
